export const logos = {
  product: {
    hdfcLife: "https://helixassets.apps-hdfclife.com/HDFC-Life.svg",
    hdfcLifeWithSubtitle:
      "https://helixassets.apps-hdfclife.com/HDFC-Life-subtitle.svg",
    hdfcPension: "https://helixassets.apps-hdfclife.com/HDFC-Pension.svg",
    hdfcInternational:
      "https://helixassets.apps-hdfclife.com/HDFC-International.svg",
    life99: "https://helixassets.apps-hdfclife.com/Life99.svg",
  },
};
